import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow_up",
  "use": "icon-arrow_up-usage",
  "viewBox": "0 0 14 8",
  "content": "<symbol viewBox=\"0 0 14 8\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-arrow_up\">\n<path d=\"M1.09822 7.27846C1.21559 7.38384 1.34459 7.43652 1.48522 7.43652C1.62584 7.43652 1.74884 7.38384 1.85422 7.27846L7.47922 1.79409L13.1042 7.27846C13.2096 7.38384 13.3326 7.43652 13.4732 7.43652C13.6138 7.43652 13.7368 7.38384 13.8422 7.27846C13.9476 7.17309 14.0003 7.05009 14.0003 6.90946C14.0003 6.76884 13.9534 6.64584 13.8597 6.54046L7.86566 0.721961C7.76028 0.616586 7.63128 0.563898 7.47866 0.563898C7.32603 0.563898 7.19703 0.616586 7.09166 0.721961L1.09766 6.54046C1.00391 6.64584 0.957031 6.76884 0.957031 6.90946C0.957031 7.05009 1.00391 7.17309 1.09766 7.27846H1.09822Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/arrow_up.svg
// module id = wvFx
// module chunks = 262